module.exports = __webpack_public_path__ + "img/SqualoSport-interno4.cf2937e9.jpeg";